<template>
    <div class="stay">
        <booking-cancel></booking-cancel>
  
        <div class=" start">
            <div class="booking-container">
                <div class="page-intro">
                    <h1>Book a room</h1>
                </div>

                <div v-if="hasExpired" class="mb-4">
                    <info-box v-bind:type="'error'">
                        <template v-slot:body>
                            <span class="heading">
                                Expired
                            </span>
                            <div>
                                <p>
                                    Your booking session expired.
                                </p>
                            </div>
                        </template>
                    </info-box>
                </div>


                <div v-if="hasError" class="mb-4">
                    <info-box v-bind:type="'error'">
                        <template v-slot:body>
                            <span class="heading">
                                Error
                            </span>
                            <div>
                                <p>
                                   An error has occurred. Please try again.
                                </p>
                            </div>
                        </template>
                    </info-box>
                </div>

                <div v-if="!isLoading" class=" has-shadow bg-white mb-5">
                    <div class="row">
                        <div class="col-24 col-xl-12 bd-r">
                            <div class="pt-4 pb-8 pt-xl-8 px-4">
                                <div class="mb-5">
                                    <h2>Book without account</h2>
                                    <p>You'll miss out on these account benefits</p>

                                    <ul>
                                        <li>View all your bookings in one place</li>
                                        <li>Easily amend your booking</li>
                                        <li>Upgrade your stay</li>

                                    </ul>
                                </div>

                                <form>
                                    <div class="form-group">
                                        <div class="btn-container">
                                            <a v-on:click="onStart()"
                                               class="btn btn--slate-blue">
                                                Start Booking

                                            </a>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>


                        <div class="col-24 col-xl-12 ">
                            <div class=" pt-8 pb-4 px-4 py-xl-8">
                                <h2>Login or register</h2>
                                <p>Login or register to make your booking smoother</p>

                                <Form @submit="onSubmit" :validation-schema="schema">
                                    <div class="form-group row mb-3">
                                        <div class="col-24">
                                            <label for="username" class="form-label">Username</label>
                                            <Field name="username" class="form-control"></Field>
                                            <ErrorMessage name="username" class="error-message" />
                                        </div>
                                    </div>

                                    <div class="form-group">

                                        <div class="form-group row">
                                            <div class="col-24">
                                                <label for="password" class="form-label">Password</label>
                                                <Field name="password" class="form-control" type="password"></Field>
                                                <ErrorMessage name="password" class="error-message" />
                                                <div class="forgot-password">Forgot your password? <a href="/account/#/password-reset">Get Reminder</a></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group mt-5">
                                        <div class="btn-container">
                                            <button type="submit" class="btn btn--slate-blue">
                                                Login
                                            </button>

                                            <a href="/account/#/register" class="btn btn--transparent-dark btn--highlight">
                                                Register
                                            </a>

                                        </div>
                                    </div>

                                </Form>

                            </div>
                        </div>


                    </div>


                </div>

                <div v-if="isLoading" class="d-flex justify-content-center">
                    <loader></loader>
                </div>

            </div>
        </div>
    </div>


</template>

<script>

    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    import { store } from '../store/index';


    import { accountStore } from '@/account/store/index';

    import BookingCancel from '../components/BookingCancel.vue';

    import Loader from '@/shared/components/Loader.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';
    export default {
        name: 'Start',
        computed: {
            session() {
                return store.getters.session
            },
            configuration() {
                return store.getters.roomConfiguration;
            },
            hasExpired() {
                return this.$route.query.hasExpired != null
            },
            hasError() {
                return this.$route.query.hasError != null
            },
        },
        components: {
            BookingCancel,
            Loader,
            Field,
            Form,
            ErrorMessage,
            InfoBox
        },
        data() {
            const schema = yup.object().shape({
                username: yup.string().required().label("Username"),
                password: yup.string().required().label("Password"),
            });

            return {
                schema,
                isLoading: false
            }
        },
        created() {
            this.isLoading = true;
            store.dispatch('getConfiguration').then(() => {
          
                if (accountStore.getters.isAuthenticated) {
                    this.onStart();
                } else {
                    this.isLoading = false;
                }
            });
        },
        methods: {

            onStart: function () {
                this.isLoading = true;

                this.$router.push({ name: 'stay_search' });
              

            },
            onSubmit(values) {
                this.isLoading = true;
                var payload = {
                    username: values.username,
                    password: values.password
                };

                accountStore.dispatch("login", payload).then(() => {
                    accountStore.dispatch("loadSession").then(() => {
                        this.onStart();
                    });
                });

            }
        }
    }
</script>


<style>
    .stay .start a:not(.btn) {
        color: #a18f5b;
        font-weight: bold;
    }

    .stay .start p {
        font-weight: normal;
    }

    .stay .start .form-label {
        font-size: 12px;
    }

    .stay .start .btn-container {
        justify-content: flex-start;
        width: 100%;
        flex-direction: row;
    }

    .stay .start .forgot-password {
        margin-top: 15px;
    }

    .stay .start ul ::marker {
        color: #a18f5b;
       
    }
</style>
